import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import TextInput from '../text-input/index';
import DropDownList from '../dropdown-list/index';
import listStyle from './dropdown-list.scss';
import Button from '../button/index';
import { CIRCLE_SUCCESS, CIRCLE_DANGER } from '../button/variants';
import { Tick, Warning, Cross } from '../../helpers/icon-dictionary';
import messages from './messages';
import ConfirmationMessage from '../../components/confirmation-message/index';
import { invalidEmailCharaters, isValidEmail } from '../../helpers/utils';

class AddTeacher extends Component {
    constructor(props) {
        super(props);
        this.state = { canSubmit: false };
        this.nameRegEx = "^[a-zA-Z0-9][a-zA-Z0-9\"*()-_,.' ]*$";
        this.handleTextInputOnChange = this.handleTextInputOnChange.bind(this);
        this.handleEmailInputOnChange = this.handleEmailInputOnChange.bind(this);
        this.getUpdatedClassrooms = this.getUpdatedClassrooms.bind(this);
        this.props.teacherTitles[0].value = this.props.intl.formatMessage(messages.teacherTitleNone);
        this.props.teacherTitles[0].key = this.props.intl.formatMessage(messages.teacherTitleNone_key);
    }

    componentDidMount() {
        this.getUpdatedClassrooms();
    }

    getUpdatedClassrooms = () => {
        const { intl, selectedProduct } = this.props;
        // default classes for the add student dropdown menu
        const defaultClassoomList = [{ key: '-1', value: intl.formatMessage(messages.classroomList, { product: selectedProduct.name }), selected: true }];
        this.setState({ classrooms: defaultClassoomList.concat(this.filterClassrooms(this.props.classes)) });
    }

    filterClassrooms = (classrooms) => {
        const classes = classrooms.map(item => ({
            key: item.classroomId,
            value: item.name
        }));
        return classes;
    }

    validateTeacherModel = () => {
        if (this.props.teacher.firstName.trim() !== '' && this.props.teacher.lastName.trim() !== '' && this.props.teacher.emailAddress.trim() !== '') {
            if (this.props.isSaveInProgress) {
                this.setState({ canSubmit: false });
            } else if (this.props.teacher.emailAddress && this.props.teacher.emailAddress.trim() !== '' && !isValidEmail(this.props.teacher.emailAddress.trim())) {
                this.setState({ canSubmit: false });
            } else {
                this.setState({ canSubmit: true });
            }
        } else {
            this.setState({ canSubmit: false });
        }
    }

    handleTextInputOnChange = (event) => {
        const regex = new RegExp(this.nameRegEx);
        const value = event.target.value;
        const field = event.target.name;
        if (value !== '' && !regex.test(value)) {
            event.preventDefault();
            return false;
        }

        this.props.teacher[field] = value;
        this.validateTeacherModel(this.props.teacher);
        return true;
    }

    handleEmailInputOnChange = (event) => {
        const regex = new RegExp(invalidEmailCharaters());
        const value = event.target.value;
        const field = event.target.name;
        if (value !== '' && !regex.test(value)) {
            event.preventDefault();
            return false;
        }

        this.props.teacher[field] = value;
        this.validateTeacherModel(this.props.teacher);
        return true;
    }

    handleListOnChange = (field, value) => {
        this.props.teacher[field] = value;
        this.validateTeacherModel(this.props.teacher);
    }

    handleOnSubmit = () => {
        this.setState({ canSubmit: false });
        this.props.handleOnAddTeacherSubmit();
    }

    handleOnCloseValidationModal = () => {
        this.setState({ canSubmit: true });
        this.props.closeAddTeacherValidationModal();
    }

    render() {
        const confirmContent = (
            <ConfirmationMessage handleOnCloseModal={this.handleOnCloseValidationModal} icon={Warning}>
                <div>{this.props.addTeacherValidationMessage}</div>
            </ConfirmationMessage>
        );

        const formContent = (
            <div className={this.props.css.addTeacherComponent}>
                <div
                    className={this.props.css.addTeacherHeader}> {this.props.intl.formatMessage(messages.inviteTeacher)} </div>
                <div className={this.props.css.list}>
                    <DropDownList
                        css={listStyle}
                        name="title"
                        onChange={this.handleListOnChange}
                        optionLength={45}
                        options={this.props.teacherTitles}
                        value={this.props.teacher.title}
                    />
                </div>
                <div className={this.props.css.firstName}><TextInput
                    handleOnChange={this.handleTextInputOnChange}
                    maxLength={50}
                    name="firstName"
                    placeholder={this.props.intl.formatMessage(messages.firstName)}
                    value={this.props.teacher.firstName}
                /></div>
                <div className={this.props.css.surName}><TextInput
                    handleOnChange={this.handleTextInputOnChange}
                    maxLength={50}
                    name="lastName"
                    placeholder={this.props.intl.formatMessage(messages.surname)}
                    value={this.props.teacher.lastName}
                /></div>
                <div className={this.props.css.emailAddress}><TextInput
                    handleOnChange={this.handleEmailInputOnChange}
                    maxLength={70}
                    name="emailAddress"
                    placeholder={this.props.intl.formatMessage(messages.emailAddress)}
                    value={this.props.teacher.emailAddress}
                /></div>
                <div className={this.props.css.list}>
                    <DropDownList
                        css={listStyle}
                        name="classroomId"
                        onChange={this.handleListOnChange}
                        optionLength={45}
                        options={this.state.classrooms}
                        value={this.props.teacher.classroomId}
                    />
                </div>
                <div className={this.props.css.actionButtonWrapper}><Button
                    containerClassName={this.props.css.btnDanger}
                    disabled={this.props.isSaveInProgress}
                    handleOnClick={this.props.handleOnCloseModal}
                    icon={Cross}
                    iconClassName={this.props.css.svgIconContainer}
                    variant={CIRCLE_DANGER}
                /><Button
                    containerClassName={this.props.css.btnSuccess}
                    disabled={!this.state.canSubmit}
                    handleOnClick={this.handleOnSubmit}
                    icon={Tick}
                    iconClassName={this.props.css.svgIconContainer}
                    variant={CIRCLE_SUCCESS}
                />
                </div>
            </div>
        );

        const finalContent = this.props.showAddTeacherValidationModal ? confirmContent : formContent;

        return (
            finalContent
        );
    }
}
AddTeacher.propTypes = {
    addTeacherValidationMessage: PropTypes.string,
    classes: PropTypes.arrayOf(PropTypes.object),
    closeAddTeacherValidationModal: PropTypes.func,
    css: PropTypes.object,
    handleOnCloseModal: PropTypes.func,
    handleOnAddTeacherSubmit: PropTypes.func,
    intl: intlShape.isRequired,
    isSaveInProgress: PropTypes.bool,
    showAddTeacherValidationModal: PropTypes.bool,
    selectedProduct: PropTypes.object,
    teacher: PropTypes.object,
    teacherTitles: PropTypes.arrayOf(PropTypes.object)
};

export default injectIntl(styleable(css)(AddTeacher));




// WEBPACK FOOTER //
// ./app/components/add-teacher/index.js